export default {
    register: { method: 'post', url: 'register' }
}